@defer {
  <h3>
    {{ (!restoring ? 'AUTOSAVE.TITLE': 'AUTOSAVE.RESTORING') | translate}}
  </h3>
  <div class="dialog-wrapper" >
    @if (!restoring) {
      <div>
        <mat-selection-list #files [(ngModel)]="selectedFiles" class="file-list">
          @for (file of unsavedFiles; track file.documentHash) {
            <mat-list-option [value]="file">
              {{file.fileName ? file.fileName : file.originalFile && file.originalFile.name ? file.originalFile.name : '' }}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    }
    @if (restoring) {
      <div class="centered">
        <mat-spinner value="warn"></mat-spinner>
      </div>
    }
    <div class="actions">
      <input type="submit" class="cb-btn" (click)="restore()" [disabled]="selectedFiles.length === 0" [value]="('AUTOSAVE.RESTORE_BTN' | translate)">
      <input type="submit" class="cb-btn" (click)="ok()" [value]="('AUTOSAVE.CLOSE_BTN' | translate)" >
    </div>
  </div>  
}